import React from 'react'

export const toTitleCase = (str) =>
  str
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')

const CSV_INJECTION_PREFIXES = ['=', '+', '-', '@', '\t', '\r']

// Defang spreadsheet-formula prefixes (OWASP CSV-injection mitigation).
// The "Download invalid rows" feature echoes user-uploaded cells back as a
// downloadable CSV — without escaping, a row author can plant
// `=HYPERLINK(...)` or `=cmd|...` that fires when a colleague opens the
// file in Excel/Sheets/Numbers.
const escapeCsvCell = (cell) => {
  const str = cell == null ? '' : String(cell)
  return CSV_INJECTION_PREFIXES.includes(str.charAt(0)) ? `'${str}` : str
}

export const downloadCsvTemplate = (templateData, filename) => {
  const csvData = templateData
    .map((row) => row.map((cell) => `"${escapeCsvCell(cell)}"`).join(','))
    .join('\n')
  const csvBlob = new Blob([csvData], { type: 'text/csv;charset=utf-8' })
  const encodedUri = URL.createObjectURL(csvBlob)
  const link = document.createElement('a')

  link.setAttribute('href', encodedUri)
  link.setAttribute('download', filename)

  document.body.appendChild(link) // Required for FF
  link.click()
  document.body.removeChild(link)
}

export const renderDescription = (description) => {
  const parts = description.split(/(<strong>|<\/strong>)/)

  return parts.map((part, index) => {
    if (part === '<strong>' || part === '</strong>') {
      return null
    }
    if (index > 0 && parts[index - 1] === '<strong>') {
      return <strong key={parts[index]}>{part}</strong>
    }

    return part
  })
}
